import { Link } from 'react-router-dom';
import { ArrowUp, ArrowUpRight } from 'lucide-react';
import { clinicInfo } from '../../data/mock-allgemein';
import { Reveal, Chapter } from './StartShared';
import { LOGO_URL } from './StartNav';

export const StartFinalCta = ({ copy }) => (
  <section id="beratung" className="start-final start-dark" aria-labelledby="consultation-heading" data-testid="start-final-cta">
    <div className="start-container">
      <Chapter number="04" label={copy.final.label} id="consultation-heading" />
      <Reveal className="start-final-layout">
        <p className="start-display" data-testid="start-final-title">{copy.final.title[0]}<br /><span className="start-muted">{copy.final.title[1]}</span></p>
        <div>
          <p className="start-final-text" data-testid="start-final-description">{copy.final.text}</p>
          <div className="start-actions">
            <a href="/#kontakt" className="start-button start-button-white" data-testid="start-cta-consultation">{copy.final.consultation}<ArrowUpRight size={17} aria-hidden="true" /></a>
            <Link to="/preisrechner" className="start-button start-button-outline" data-testid="start-cta-calculator">{copy.final.calculator}<ArrowUpRight size={17} aria-hidden="true" /></Link>
          </div>
          <p className="start-final-note start-mono" data-testid="start-final-note">{copy.final.note}</p>
        </div>
      </Reveal>
    </div>
  </section>
);

export const StartFooter = ({ copy }) => (
  <footer className="start-footer start-dark" data-testid="start-footer">
    <div className="start-container">
      <div className="start-footer-grid">
        <div className="start-footer-brand"><img src={LOGO_URL} alt="Dion Hair Clinic" width="128" height="78" data-testid="start-footer-logo" /><p data-testid="start-footer-tagline">{copy.footer.tagline}</p></div>
        <div><h3>{copy.footer.contact}</h3><a data-testid="start-footer-email" href={`mailto:${clinicInfo.email}`}>{clinicInfo.email}</a><a data-testid="start-footer-phone" href={`tel:${clinicInfo.phone.replace(/\s/g, '')}`}>{clinicInfo.phone}</a></div>
        <div><h3>{copy.footer.visit}</h3><address data-testid="start-footer-address">{clinicInfo.address.street}<br />{clinicInfo.address.city}</address></div>
        <div><h3>{copy.footer.explore}</h3><Link to="/blog" data-testid="start-footer-blog">{copy.footer.blog}<ArrowUpRight size={13} aria-hidden="true" /></Link><Link to="/longhairfue" data-testid="start-footer-longhair">Long Hair FUE<ArrowUpRight size={13} aria-hidden="true" /></Link></div>
      </div>
      <div className="start-footer-bottom">
        <p data-testid="start-footer-copyright">© {new Date().getFullYear()} Dion Hair Clinic</p>
        <div className="start-legal-links"><Link to="/impressum" data-testid="start-footer-impressum">{copy.footer.imprint}</Link><Link to="/datenschutz" data-testid="start-footer-datenschutz">{copy.footer.privacy}</Link><Link to="/agb" data-testid="start-footer-agb">{copy.footer.terms}</Link></div>
        <a href="#start-top" data-testid="start-back-to-top" className="start-back-top">{copy.footer.back}<ArrowUp size={14} aria-hidden="true" /></a>
      </div>
    </div>
  </footer>
);